import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IInstructionFeedbackActivityTemplateProduct } from "@/interfaces/api/instruction-feedback-activity-template-product.interface.ts"

export class InstructionFeedbackActivityTemplateProductRepository extends BaseRepository<IInstructionFeedbackActivityTemplateProduct> {
  resourcePath = "planning/instruction-feedback-activity-template-products"
}
